import {
  IsString,
  IsNotEmpty,
} from 'class-validator';

export class LocalizationDto {
  @IsNotEmpty()
  @IsString()
  pageTitle: string;

  @IsNotEmpty()
  @IsString()
  pageLabel: string;

  @IsNotEmpty()
  @IsString()
  contactInfo: string;

  @IsNotEmpty()
  @IsString()
  firstName: string;

  @IsNotEmpty()
  @IsString()
  lastName: string;

  @IsNotEmpty()
  @IsString()
  paymentMethod: string;

  @IsNotEmpty()
  @IsString()
  creditCard: string;

  @IsNotEmpty()
  @IsString()
  nameOnCard: string;

  @IsNotEmpty()
  @IsString()
  cardNumber: string;

  @IsNotEmpty()
  @IsString()
  exp: string;

  @IsNotEmpty()
  @IsString()
  cvv: string;

  @IsNotEmpty()
  @IsString()
  agree: string;

  tAndCAutoagreeIntro?: string;

  @IsNotEmpty()
  @IsString()
  toc: string;

  @IsNotEmpty()
  @IsString()
  invoice: string;

  @IsNotEmpty()
  @IsString()
  reservation: string;

  @IsNotEmpty()
  @IsString()
  amount: string;

  @IsNotEmpty()
  @IsString()
  pay: string;

  @IsNotEmpty()
  @IsString()
  cancel: string;

  @IsNotEmpty()
  @IsString()
  successLabel: string;

  @IsNotEmpty()
  @IsString()
  linkExpired: string;

  @IsNotEmpty()
  @IsString()
  contactProperty: string;

  @IsNotEmpty()
  @IsString()
  guest: string;

  @IsNotEmpty()
  @IsString()
  guestEmail: string;

  @IsNotEmpty()
  @IsString()
  cardholder: string;

  @IsNotEmpty()
  @IsString()
  remainingBalance: string;
};
